import { SDK_SEASON } from '@pff-consumer/schema'

export const getSeasonForGrades = (season: number | undefined, isInSeason: boolean) => {
  if (!season) {
    return SDK_SEASON
  }
  // For off-season display the previous season grades
  return isInSeason ? season : season - 1
}
